import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Review } from '../../clcd.service';

@Component({
  selector: 'ag-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewComponent implements OnInit {
  @Input() review: Review;
  @Input() reviewLength: number;

  preview: string;
  more: string;
  showMore: boolean;
  constructor() {}

  ngOnInit(): void {
    this.preview = this.review.content.substring(
      0,
      this.review.content.length > this.reviewLength
        ? this.reviewLength
        : this.review.content.length,
    );
    this.more =
      this.preview.length !== this.review.content.length
        ? this.review.content.substring(this.reviewLength, this.review.content.length)
        : '';
  }
}
